import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconUser } from '#src/atoms/icons/system/iconUser.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { FlagAvatar } from '#src/components/country/FlagAvatar/index.tsx';

const Container = styled.div`
  position: relative;
  width: 64px;
  height: 64px;
  flex-shrink: 0;
`;

const Circle = styled(Horizontal).attrs({ gap: 0, center: true })`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--c-nd-50);
  overflow: hidden;
  color: var(--c-nd-400);
  font-size: 32px;
`;

const StyledFlagAvatar = styled(FlagAvatar)`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const UserAvatarWithFlag = () => {
  return (
    <Container>
      <Circle>
        <FontAwesomeIcon icon={iconUser} />
      </Circle>
      <StyledFlagAvatar
        country={{ name: 'France', slug: 'FR' }}
        type="flat"
        size={20}
      />
    </Container>
  );
};
